import { render } from "./mohitsizst.vue?vue&type=template&id=0e47b444"
import script from "./mohitsizst.vue?vue&type=script&lang=js"
export * from "./mohitsizst.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/pamenar-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__